module.exports = __webpack_public_path__ + "img/shot_bigtx120601.9ad0c9c1.png";